import React, { useContext, useEffect, useMemo } from "react";
import {
  ComponentRef,
  getComponentRef,
} from "../../message/components/records/MessageTagUtil";
import axios from "axios";
import moment from "moment";
import { AccountDetailsContext } from "../../message/models/AccountDetailsContext";
import { UserContext } from "../../message/models/UserContext";
import { UserListContext } from "../../message/models/UserListContext";
import { AppContext } from "../../message/contexts/AppContext";
import { Box, Button, Typography } from "@mui/material";
import { proxyOptionsWithToken } from "../../util/ProxyOptions";

export default function MessageAcknowledgmentButton(props) {
  const {
    messageObject,
    label,
    placeholderText,
    id,
    readOnly,
    users,
    onChange,
  } = props;
  const {
    handleSubComponentLoaded = (
      subComponent = { ...ComponentRef },
      isLoaded = false
    ) => {},
  } = props;
  const { itemIndex, level, messageTime } = props;

  const { accountDetails } = useContext(
    AccountDetailsContext.AccountDetailsContext
  );
  const { currentUser } = useContext(UserContext.UserContext);
  const { userList } = useContext(UserListContext.UserListContext);
  const { snackbar, setSnackbar } = useContext(AppContext.SnackbarContext);

  const isUserAlreadyAdded = useMemo(() => {
    return users.find((user) => user.userId === currentUser.id);
  }, [users]);

  useEffect(() => {
    handleSubComponentLoaded(
      getComponentRef(
        "MessageAcknowledgmentButton",
        itemIndex,
        level,
        messageTime
      ),
      true
    );
  }, []);

  const handleMessageAcknowledge = async () => {
    try {
      const res = await axios.post(
        accountDetails?.baseUrl + "/acknowledgeMessage",
        {
          componentId: id,
          messageId: messageObject.id,
          userId: currentUser.id,
        },
        proxyOptionsWithToken(accountDetails?.token)
      );

      if (res.status === 200) {
        setSnackbar({
          ...snackbar,
          open: true,
          severity: "success",
          message: "Message Acknowledged!",
        });
      } else {
        setSnackbar({
          ...snackbar,
          open: true,
          severity: "error",
          message: "Message Acknowledge error",
        });
      }
    } catch (error) {
      setSnackbar({
        ...snackbar,
        open: true,
        severity: "error",
        message: "Message Acknowledge error",
      });
    }
  };

  const renderUsersList = () => {
    if (!isUserAlreadyAdded) {
      return false;
    }

    return (
      <Box>
        <Typography style={{ fontWeight: "bold", color: "#726EFF" }}>
          {"Users: "}
        </Typography>
        <Box>
          {users.map((user) => {
            const _user = userList?.find((u) => u.id === user.userId);
            return (
              <Box key={user.userId}>
                {`${moment(user.date).format("M/D h:mm a")} ${
                  _user.firstName
                } ${_user.lastName}`}
              </Box>
            );
          })}
        </Box>
      </Box>
    );
  };

  const renderElement = () => {
    return (
      <>
        <Typography style={{ fontWeight: "bold" }}>{label}</Typography>
        <Button
          style={{
            border: "1px solid",
            marginTop: 5,
          }}
          onClick={handleMessageAcknowledge}
          disabled={!readOnly || isUserAlreadyAdded}
        >
          <Typography>{placeholderText}</Typography>
        </Button>
        {renderUsersList()}
      </>
    );
  };

  return renderElement();
}
